export default __webpack_public_path__ + "media/images/gradient_nav_bar-dbac88db25c02bfb3e9e6bbbacfb4059.png";